<template>
  <main-layout>
    <b-btn block @click="$router.push({name:'MailListVue'})">Voir liste mail</b-btn>
    <b-paginated-table
        :items="users"
        :fields="fields"
        :busy="busy"
        :total-rows="rows"
        persistant
    >
      <template #cell(acces_ecole)="{value, item}">
        <b-checkbox switch :checked="!!value" @input="giveAccess($event,item)"></b-checkbox>
      </template>
      <template #cell(Actions)="{item}">
        <b-button variant="primary" @click="GoToDetails(item)" size="sm" class="mr-1">Voir</b-button>
      </template>
    </b-paginated-table>
  </main-layout>
</template>

<script>
import {User} from "@/js/caller";
import BPaginatedTable from "@/components/BPaginatedTable";

export default {
  name      : "EleveList",
  components: {BPaginatedTable},
  data() {
    return {
      fields: [
        {key: 'mail', sortable: true, filterable: true},
        {key: 'prenom', sortable: true, filterable: true},
        {key: 'acces_ecole', label: 'Acces Ecole'},
        'Actions'
      ],
      users : [],
      busy  : true,
      rows  : 0,
    }
  },
  methods: {
    GoToDetails(item) {
      this.$router.push({name: "EleveView", params: {id: item.id}})
      //History.GoTo("EleveView", {user: item})
    },
    giveAccess($event, item) {
      if (!!item.acces_ecole === $event) return;
      const acces_ecole = $event ? new Date() : null;
      User.UpdateUser({
        id         : item.id,
        acces_ecole: acces_ecole.getTime()
      }).then(() => item.acces_ecole = acces_ecole.toISOString())
    }
  },
  created() {
    User.GetUsers().then(users => {
      this.users = users;
      this.rows = users.length;
      this.busy = false;
    })
  }
}
</script>

<style scoped>

</style>